module.exports = __webpack_public_path__ + "static/site-header-logo-1ce40d5d03ef39b0daa2e5da078b724f.png";